import classes from "./LabeledFillRows.module.css";

interface Props {
  labels: string[];
  /**
   * Fixed pitch per row. Given this, rows sit at a consistent rhythm at the top
   * and any slack is left below — which is how the client's mock-up reads, and it
   * lets the surrounding card hug its content. Omit it to divide the container
   * height evenly instead.
   */
  rowHeight?: number;
}

/** Label plus a blank write-in rule, one row per label. */
const LabeledFillRows = ({ labels, rowHeight }: Props): JSX.Element => (
  <div className={classes.rows}>
    {labels.map((label, i) => (
      <div
        className={classes.row}
        key={`${label}-${i}`}
        style={rowHeight ? { flex: `0 0 ${rowHeight}px` } : undefined}
      >
        <span className={classes.label}>{label}</span>
        <span className={classes.line} />
      </div>
    ))}
  </div>
);

export default LabeledFillRows;
